export const fetchStatuses = {
  idle: 'idle',
  pending: 'pending',
  succeeded: 'succeeded',
  failed: 'failed',
}

export const notifStatus = {
  read: 'read',
  unread: 'unread',
}
